<template>
    <div class="max-w-screen-xl mx-auto mt-12 md:mt-18 lg:mt-20 xl:mt-24 md:mb-8 mb-6 px-4">

        <h2 class="text-2xl sm:text-3xl font-semibold mb-10" v-html="dataLocales.any_content.title">

        </h2>
        <div class="grid grid-cols-12 lg:gap-8">
            <div class="lg:col-span-7 col-span-12">
                <div class="mb-6" v-for="post in dataLocales.data">
                    <h3 class="text-xl sm:text-2xl font-semibold mb-3" v-html="post.title"></h3>
                    <div class="text-base lg:text-lg list-disc list-inside" v-html="post.description">

                    </div>

                </div>

                <div class="mt-4">
                    <a href="https://app.qrgateway.com/page-builder" target="_blank" rel="nofollow"
                        class="flex items-center gap-2 h-[50px] px-8 w-fit rounded-3xl bg-success text-white drop-shadow-md hover:drop-shadow-xl">{{
                            $t('try_page_editor') }}</a>
                </div>
            </div>
            <div class="lg:col-span-5 lg:block hidden">
                <nuxt-img loading="lazy" src="/gallery.png" alt="images-to-qr-code" height="420px" format="webp" />
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import MultiDataLocale from '~~/config/interface/MultiDataLocale';


const dataLocales = new MultiDataLocale([
    {
        locale: "en",
        title: "📸 <span class='text-success'>Scan Qr Code</span> to view images",
        data: [
            {
                title: "Flexible image styling ",
                description: "<ul class='list-disc list-inside'> <li>Switch between image display options, including top positioning or full-screen display</li> <li>Display multiple images in a tiled or carousel layout</li> <li>Arrange images in a vertical or horizontal order</li> <li>Manually or automatically advance through images with set time intervals</li> </ul>"
            },
            {
                title: "Flexible combination of graphics, text, audio/video, and tables.",
                description: "<p> Freedom to select various components, easily modify content layout, change color schemes, etc. </p> <p>Enhance the beauty of content display.</p>"
            }
        ]
    },
    {
        locale: "vi",
        title: "📸 <span class='text-success'>Quét mã QR</span> để xem hình ảnh",
        data: [
            {
                title: "Tùy chỉnh hiển thị ảnh linh hoạt",
                description: "<ul class='list-disc list-inside'> <li>Chuyển đổi giữa các tùy chọn hiển thị ảnh, bao gồm vị trí trên cùng hoặc hiển thị toàn màn hình</li> <li>Hiển thị nhiều hình ảnh trong bố cục dạng lát gạch hoặc carousel</li> <li>Sắp xếp hình ảnh theo thứ tự dọc hoặc ngang</li> <li>Chuyển đổi ảnh theo khoảng thời gian được thiết lập tự động hoặc thủ công</li> </ul>"
            },
            {
                title: "Kết hợp linh hoạt các thành phần đồ họa, văn bản, âm thanh / video và bảng.",
                description: "<p> Tự do lựa chọn nhiều thành phần khác nhau, dễ dàng chỉnh sửa bố cục nội dung, thay đổi màu sắc, vv. </p> <p> Tăng cường tính thẩm mỹ cho hiển thị nội dung.</p>"
            }
        ]
    },
    {
        locale: "de",
        title: "📸 <span class='text-success'>QR-Code scannen</span> um Bilder anzuzeigen",
        data: [
            {
                title: "Flexible Bildgestaltung",
                description: "<ul class='list-disc list-inside'> <li>Wechseln Sie zwischen Bildanzeigeoptionen, einschließlich Top-Positionierung oder Vollbildanzeige</li> <li>Zeigen Sie mehrere Bilder in einem Kachel- oder Karussell-Layout an</li> <li>Anordnung von Bildern in vertikaler oder horizontaler Reihenfolge</li> <li>Manuell oder automatisch durch Bilder mit festgelegten Zeitintervallen vorrücken</li> </ul>"
            },
            {
                title: "Flexible Kombination von Grafiken, Text, Audio / Video und Tabellen.",
                description: "<p> Freiheit bei der Auswahl verschiedener Komponenten, einfache Änderung des Layouts des Inhalts, Änderung der Farbschemata usw. </p> <p> Verbessern Sie die Schönheit der Inhaltsanzeige.</p>"
            }
        ]
    },
    {
        locale: "fr",
        title:
            "📸 <span class='text-success'>Scannez le code QR</span> pour voir les images",
        data: [
            {
                title: "Style d'image flexible",
                description:
                    "<ul class='list-disc list-inside'> <li>Changez d'options d'affichage d'image, y compris la position supérieure ou l'affichage plein écran</li> <li>Affichez plusieurs images dans une disposition en mosaïque ou en carrousel</li> <li>Disposez les images verticalement ou horizontalement</li> <li>Faites avancer les images manuellement ou automatiquement avec des intervalles de temps définis</li> </ul>",
            },
            {
                title:
                    "Combinaison flexible de graphiques, de texte, d'audio/vidéo et de tableaux.",
                description:
                    "<p> Liberté de choisir divers composants, de modifier facilement la mise en page du contenu, de changer les schémas de couleurs, etc. </p> <p>Améliorez la beauté de l'affichage du contenu.</p>",
            },
        ],
    },
    { "locale": "it", "title": "📸 <span class='text-success'>Scansiona il codice QR</span> per visualizzare le immagini", "data": [{ "title": "Stile flessibile dell'immagine", "description": "<ul class='list-disc list-inside'> <li>Cambia tra opzioni di visualizzazione dell'immagine, inclusa la posizione superiore o la visualizzazione a schermo intero</li> <li>Mostra più immagini in una disposizione a mosaico o a carosello</li> <li>Disponi le immagini in ordine verticale o orizzontale</li> <li>Avanza manualmente o automaticamente attraverso le immagini con intervalli di tempo predefiniti</li> </ul>" }, { "title": "Combinazione flessibile di grafica, testo, audio/video e tabelle.", "description": "<p> Libertà di selezionare vari componenti, modificare facilmente la disposizione del contenuto, cambiare gli schemi di colore, ecc. </p> <p>Migliora la bellezza della visualizzazione del contenuto.</p>" }] },
    {
        "locale": "ja",
        "title": "📸 画像を表示するには <span class='text-success'>QRコードをスキャン</span> してください",
        "data": [
            {
                "title": "柔軟な画像スタイリング",
                "description": "<ul class='list-disc list-inside'><li>上部位置や全画面表示などの画像表示オプションの切り替え</li><li>タイル状態またはカルーセルレイアウトで複数の画像を表示</li><li>縦または横の順序で画像を配置</li><li>設定された時間間隔で手動または自動的に画像を進める</li></ul>"
            },
            {
                "title": "グラフィック、テキスト、音声/ビデオ、および表の柔軟な組み合わせ。",
                "description": "<p>さまざまなコンポーネントを選択して、簡単にコンテンツレイアウトを変更し、カラースキームを変更などが可能です。</p><p>コンテンツ表示の美しさを高めます。</p>"
            }
        ]
    }, {
        "locale": "zh",
        "title": "📸 扫描二维码查看图片<span class='text-success'>QR码</span>",
        "data": [
            {
                "title": "灵活的图像样式",
                "description": "<ul class='list-disc list-inside'><li>切换图像显示选项，包括顶部定位或全屏显示</li><li>在平铺或旋转木马布局中显示多个图像</li><li>按垂直或水平顺序排列图像</li><li>使用设置的时间间隔手动或自动推进图像</li></ul>"
            },
            {
                "title": "图形、文本、音频/视频和表格的灵活组合。",
                "description": "<p>自由选择各种组件，轻松修改内容布局，更改颜色方案等。</p><p>提高内容显示的美感。</p>"
            }
        ]
    },
    {
        locale: "es",
        title: "📸 <span class='text-success'>Escanee el código QR</span> para ver imágenes",
        data: [
            {
                title: "Estilo de imagen flexible",
                description: "<ul class='list-disc list-inside'> <li>Cambie entre opciones de visualización de imágenes, incluida la posición superior o la visualización en pantalla completa</li> <li>Muestre varias imágenes en un diseño de mosaico o carrusel</li> <li>Ordene las imágenes en orden vertical u horizontal</li> <li>Avance manual o automático a través de imágenes con intervalos de tiempo establecidos</li> </ul>"
            },
            {
                title: "Combinación flexible de gráficos, texto, audio/video y tablas",
                description: "<p> Libertad para seleccionar varios componentes, modificar fácilmente el diseño del contenido, cambiar esquemas de color, etc. </p> <p>Mejora la belleza de la visualización de contenido.</p>"
            }
        ]
    },
    {
        locale: "nl",
        title: "📸 <span class='text-success'>Scan de QR-code</span> om afbeeldingen te bekijken",
        data: [
            {
                title: "Flexibele beeldstijl",
                description: "<ul class='list-disc list-inside'> <li>Wissel tussen beeldweergaveopties, waaronder bovenste positionering of volledige schermweergave</li> <li>Toon meerdere afbeeldingen in een betegeld of carrousel-indeling</li> <li>Rangschik afbeeldingen verticaal of horizontaal</li> <li>Handmatig of automatisch vooruitspoelen door afbeeldingen met ingestelde tijdintervallen</li> </ul>"
            },
            {
                title: "Flexibele combinatie van grafische elementen, tekst, audio/video en tabellen",
                description: "<p> Vrijheid om verschillende componenten te selecteren, de lay-out van de inhoud eenvoudig aan te passen, kleurenschema's te wijzigen, etc. </p> <p>Verbeter de schoonheid van de weergave van de inhoud.</p>"
            }
        ]
    },
    {
        locale: "pt",
        title: "📸 <span class='text-success'>Escanear código QR</span> para visualizar imagens",
        data: [
            {
                title: "Estilo flexível de imagem",
                description: "<ul class='list-disc list-inside'> <li>Alternar entre opções de exibição de imagem, incluindo posicionamento superior ou exibição em tela cheia</li> <li>Exibir várias imagens em layout de mosaico ou carrossel</li> <li>Organizar imagens em ordem vertical ou horizontal</li> <li>Avançar manual ou automaticamente pelas imagens com intervalos de tempo definidos</li> </ul>"
            },
            {
                title: "Combinação flexível de gráficos, texto, áudio/vídeo e tabelas",
                description: "<p> Liberdade para selecionar vários componentes, modificar facilmente o layout do conteúdo, alterar esquemas de cores, etc. </p> <p>Melhore a beleza da exibição do conteúdo.</p>"
            }
        ]
    }
])
</script>